import '@/i18n';
import { hydrateRoot } from 'react-dom/client';
import '@/styles/main.scss';
import AppRoot from './AppRoot';

hydrateRoot(document.getElementById('root')!, <AppRoot />);
